const IS_SIGNUP_KEY = "socialAuthIsSignup";
const PROVIDER_KEY = "socialAuthProvider";

/**
 * SocialSigninButton stashes the provider before handing off to OAuth so
 * SessionProvider can attribute an existing-user login. Signup classification
 * comes only from the server-issued registration receipt.
 *
 * IS_SIGNUP_KEY is cleanup-only for browsers that still have the old marker.
 */
export function clearSocialAuthMarkers() {
	if (typeof window === "undefined") {
		return;
	}

	try {
		localStorage.removeItem(IS_SIGNUP_KEY);
		localStorage.removeItem(PROVIDER_KEY);
	} catch (e) {
		console.error("Error clearing social auth markers:", e);
	}
}
